import type { Locale } from '@/types'
import type { Dictionary } from '@/i18n/de'

import { useRouter } from 'next/router'
import { de } from '@/i18n/de'
import { fr } from '@/i18n/fr'
import { en } from '@/i18n/en'
import { ar } from '@/i18n/ar'

const DICTIONARIES: Record<Locale, Dictionary> = { de, fr, en, ar }

export const LANGUAGE_NAMES: Record<Locale, string> = {
    de: 'Deutsch',
    fr: 'Français',
    en: 'English',
    ar: 'العربية'
}

export const toLocale = (value: string | null | undefined): Locale => (value === 'fr' || value === 'en' || value === 'ar' ? value : 'de')

export const getDictionary = (locale: string | null | undefined): Dictionary => DICTIONARIES[toLocale(locale)]

export const fill = (template: string, values: Record<string, string | number>): string =>
    template.replace(/\{(\w+)\}/g, (match, key: string) => (key in values ? String(values[key]) : match))

export const plural = (count: number, one: string, other: string): string => fill(count === 1 ? one : other, { count })

export const useI18n = () => {
    const router = useRouter()
    const locale = toLocale(router.locale)

    return {
        locale,
        t: DICTIONARIES[locale],
        dir: locale === 'ar' ? 'rtl' as const : 'ltr' as const,
        locales: (router.locales ?? ['de']).map(toLocale)
    }
}

export type { Dictionary }
